import React from "react";

import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { showRequests } from "../../../../MyApi/sb/requests";

import LoadingSpinner from "../../../../Components/UI/spinner";
import PageHeader from "../../../../Components/UI/PageHeader";

import RequestDetalis from "../../../../Components/sb/requests/requestsShow/requestsDetalis";

const RequestsShow = () => {
  const { id } = useParams();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const { data, isLoading } = useQuery(["showRequests", id, lang], () =>
    showRequests(id, lang)
  );
  const Requests = data?.data || {};

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!data) {
    return <div>no data available</div>;
  }
  return (
    <div>
      <PageHeader title="Requests Detalis" showBack={true} />
      <RequestDetalis Requests={Requests} />
    </div>
  );
};

export default RequestsShow;
